export default "assets/images/numbers-background-3e7e7424.jpg";